module.exports = __webpack_public_path__ + "img/brlxcj.e735a4fe.png";